module.exports = __webpack_public_path__ + "static/media/main.741604d8.png";